<ion-header>
  <ion-toolbar mode="ios">
      <ion-buttons slot="start" class="pty-header-buttons">
          <ion-button size="large" class="pty-header-button ion-margin-horizontal" (click)="close()">
              <ion-ripple-effect></ion-ripple-effect>
              <ion-icon name="close"></ion-icon>
          </ion-button>
      </ion-buttons>
      <ion-title>
          Bible Chapter
      </ion-title>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <ul class="list-inline">
      <li class="list-inline-item">
          <ion-text class="bible-info">{{bookName}} {{chapterId}}:{{bookOrder}}</ion-text>
      </li>
      <li class="list-inline-item">
          <ion-text class="bible-info">{{language}}</ion-text>
      </li>
  </ul>
  <div class="chapterContent">

    <div class="chapterContent__ul">
        <!-- <li class="chapterContent__li" *ngFor="let track of playlist" (click)="start(track)">
                {{track.name}}
        </li> -->
        <ion-button (click)="showCheckBoxes()">{{ 'ShareMultipleVerses' | translation }}</ion-button>

        <div class="list-media" *ngFor="let verse of BibleBooksText">
        <ion-checkbox style="margin-right: 20px;" [(ngModel)]="verse.isChecked" *ngIf="showCheckBox"  (ngModelChange)="getSelectedVerses($event,verse)" ></ion-checkbox>

        <div  [ngClass]="{'highlighted':verse.isHighlighted}" class="list-media-body chapterContent__li" 
            (press)="showOptions($event, verse)"    (click)="setCurrentVerse(verse.verse_text, verse)" > 
            {{verse.verse_text}}
        </div>
    </div>
</div>
</div>
</ion-content>
<ion-footer class="bible-footer" >
  <div class="app-container">
      <ion-toolbar class="bible-footer__toolbar">
          <ion-grid>
              <ion-row>
                  <ion-col size="12" class="ion-text-right">
                      <ion-button (click)="shareVerse()" color="light" size="small" class="playerBtn small light">
                          <ion-icon slot="icon-only" name="share"></ion-icon>
                      </ion-button>&nbsp;
                      <ion-button color="light" size="small" class="playerBtn small light">
                          <ion-icon slot="icon-only" name="brush"></ion-icon>
                      </ion-button>
                  </ion-col>
              </ion-row>
          </ion-grid>
          <div class="selected-content-div">
              <!-- <p>{{activeTrack.name}}</p> -->
              <p *ngIf="currentVerse">{{currentVerse}}</p>
          </div>
          <!-- <ion-row class="ion-justify-content-center ion-align-items-center">
              <ion-col size="2" sizeLg="auto" class="ion-text-center">
                  <ion-text class="audioPlayer__text">{{current_duration ? current_duration : ''}}</ion-text>
              </ion-col>
              <ion-col size="8" sizeLg="10" class="ion-text-center">
                  <ion-range class="range range--audioPlayer" #range [(ngModel)]="progress" max="100"
                             (touchend)="seek()"
                             (mouseup)="seek()"></ion-range>
              </ion-col>
              <ion-col size="2" sizeLg="auto" class="ion-text-center">
                  <ion-text class="audioPlayer__text">{{current_total_duration ? current_total_duration : '0:0'}}
                  </ion-text>
              </ion-col>
          </ion-row>
          <ion-row class="ion-justify-content-center ion-align-items-center">
              <ion-col size="2" sizeLg="3" class="ion-text-center"> -->
                  <!--<ion-button (click)="backward()" class="playerBtn small light">-->
                      <!--<ion-icon slot="icon-only" name="rewind" size="small" color="light"></ion-icon>-->
                  <!--</ion-button>-->
                  <!-- <ion-button color="light" (click)="backward()" class="playerBtn small light">
                      <ion-icon slot="icon-only" name="rewind" size="small"></ion-icon>
                  </ion-button>
              </ion-col>
              <ion-col size="8" sizeLg="6" class="ion-text-center">
                  <ion-button color="light" (click)="prev()" class="playerBtn small light">
                      <ion-icon slot="icon-only" name="skip-backward" size="small"></ion-icon>
                  </ion-button>&nbsp;
                  <ion-button size="large" color="primary" class="playerBtn big dark" (click)="togglePlayer(false)"
                              *ngIf="!isPlaying">
                      <ion-icon slot="icon-only" name="play" style="padding-left: 4px;"></ion-icon>
                  </ion-button>
                  <ion-button size="large" color="primary" class="playerBtn big dark" (click)="togglePlayer(true)"
                              *ngIf="isPlaying">
                      <ion-icon slot="icon-only" name="pause"></ion-icon>
                  </ion-button>&nbsp;
                  <ion-button size="small" color="light" class="playerBtn small light" (click)="prev()">
                      <ion-icon slot="icon-only" name="skip-forward" size="small"></ion-icon>
                  </ion-button>
              </ion-col>
              <ion-col size="2" sizeLg="3" class="ion-text-center">
                  <ion-button (click)="forward()" size="small" color="light" class="playerBtn small light">
                      <ion-icon slot="icon-only" name="fastforward" size="small"></ion-icon>
                  </ion-button>
              </ion-col>
          </ion-row> -->
      </ion-toolbar>
  </div>
</ion-footer>
